import AlphaFilter from './alpha-filter';

export default AlphaFilter;